export default theme => ({
    photoUploadDialog: {},
    container: {
        flex: 1,
        backgroundColor: 'white',
        padding: 20,
    
        '& > *': {
          alignSelf: 'stretch',
        },
      },
    
      dropzone: {
        backgroundColor: '#F8F8F8',
        borderStyle: 'dashed',
        borderWidth: 2,
        borderColor: 'rgba(0,0,0,0.1)',
        color: 'rgba(0,0,0,0.4)',
        padding: 20,
        textAlign: 'center',
      },
});
